import type OpenIdConnector from "../data/openIdConnector";
import type CurrentUser from "../entities/currentUser";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";

export default class SessionRepository extends RepositoryBase<OpenIdConnector> {
  constructor(protected apiFactory: ReturnType<typeof OpenIdConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  current(): Promise<CurrentUser | undefined> {
    return this.callApi(api => api.all("connect").all("userinfo").get<CurrentUser>());
  }

  logoutUrl(token: string, redirect: string): string {
    const query = this.apiFactory().getQueryString({ id_token_hint: token, post_logout_redirect_uri: redirect });
    const baseUrl = this.apiFactory().all("connect").all("endsession").getURL();
    return `${baseUrl}?${query}`;
  }
}
